import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Check, X } from "lucide-react";
import { buildComplianceChecklist } from "@/lib/personnel/compliance";
import type { InstructorDocument } from "@/lib/personnel/documents";

export default function ComplianceChecklist({
  instructor, documents,
}: { instructor: any; documents: InstructorDocument[] }) {
  const items = buildComplianceChecklist({ instructor, documents });
  const missing = items.filter((i) => i.status === "missing").length;
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Compliance Checklist</CardTitle>
        <CardDescription>
          {missing === 0 ? "All requirements met." : `${missing} item${missing === 1 ? "" : "s"} still needed.`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
          {items.map((i) => (
            <li key={i.key} className="flex items-center gap-2">
              {i.status === "complete"
                ? <Check className="h-4 w-4 text-green-600 shrink-0" />
                : <X className="h-4 w-4 text-red-600 shrink-0" />}
              <span className={i.status === "complete" ? "text-green-800" : "text-red-700 font-medium"}>{i.label}</span>
              {i.detail && <span className="text-xs text-muted-foreground">· {i.detail}</span>}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
